/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth, AuthLayout} from '../modules/auth'
import {App} from '../App'
import {VerifyEmail} from '../modules/auth/components/VerifyEmail'
import ServiceLevelRoutes from '../pages/service-level/ServiceLevelRoutes'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
//const {PUBLIC_URL} = process.env
const PUBLIC_URL = ''

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route element={<AuthLayout />}>
            <Route path='verify-email/:token/:userGuid/:email' element={<VerifyEmail />} />
          </Route>
          {currentUser ? (
            <>
              {/* Service Level: shell próprio, fora do MasterLayout. Fica aqui
                  (e não em PrivateRoutes) porque lá o padrão ':dashboardId/dashboard'
                  tem precedência maior e capturaria /service-level/dashboard. */}
              <Route path='service-level/*' element={<ServiceLevelRoutes />} />
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/home' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
